class CustomField extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    this.errorMessage = this.querySelector('.custom_error')

    if (this.input) {
      this.input.addEventListener('change', (event) => this.onChange(event));
    }
    if (this.select) {
      this.select.addEventListener('change', (event) => this.onChange(event));
    }
  }

  onChange(event) {
    const propertyName = event.currentTarget.name;       // es. "_participant_1_name_gt-am"
    const value = event.currentTarget.value;             // valore digitato o selezionato
    const itemId = event.currentTarget.dataset.lineitem; // ID dell'item a carrello (stringa)

    // Se il campo è di tipo "date", eseguiamo la verifica dell'età
    if (event.currentTarget.type === "date") {
      if (!this.isValidAge(value)) {
        this.showErrorMessage();
        event.currentTarget.value = ""; // Resetta il campo se non valido
        return;
      } else {
        this.hideErrorMessage(); // Rimuove il messaggio di errore se l'età è valida
      }
    }

    // Salviamo la property nel CartPropertiesStore
    CartPropertiesStore.setProperty(itemId, propertyName, value);
  }

  /**
   * Verifica se la data inserita corrisponde a un'età di almeno 18 anni
   */
  isValidAge(birthdate) {
    const birthDate = new Date(birthdate);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Controllo se il compleanno di quest'anno è già passato
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      return age - 1 >= 18; // Non ha ancora compiuto 18 anni
    }
    return age >= 18;
  }

  /**
   * Mostra un messaggio di errore dentro il custom-field
   */
  showErrorMessage() {
    this.errorMessage.classList.remove('hidden') // Mostra il messaggio
  }

  /**
   * Nasconde il messaggio di errore
   */
  hideErrorMessage() {
    this.errorMessage.classList.add('hidden') // Nasconde il messaggio
  }

  /**
   * Se ti serve rimuovere più property in un colpo solo:
   *   this.removeCartItemProperties(itemId, ['prop1', 'prop2']);
   */
  removeCartItemProperties(itemId, propertyNames) {
    CartPropertiesStore.removeProperties(itemId, propertyNames);
  }
}

customElements.define('custom-field', CustomField);
